/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function ExternalLink(props) {
  return (
    <svg {...props} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25033 1.91699H10.0003H13.3337C13.7479 1.91699 14.0837 2.25278 14.0837 2.66699V6.00033V6.75033H12.5837V6.00033V4.47765L7.86399 9.19732L7.33366 9.72765L6.273 8.66699L6.80333 8.13666L11.523 3.41699H10.0003H9.25033V1.91699ZM2.52719 3.86052C2.91789 3.46982 3.44779 3.25033 4.00033 3.25033H7.33366H8.08366V4.75033H7.33366H4.00033C3.84562 4.75033 3.69724 4.81178 3.58785 4.92118C3.47845 5.03058 3.41699 5.17895 3.41699 5.33366V12.0003C3.41699 12.155 3.47845 12.3034 3.58785 12.4128C3.69724 12.5222 3.84562 12.5837 4.00033 12.5837H10.667C10.8217 12.5837 10.9701 12.5222 11.0795 12.4128C11.1889 12.3034 11.2503 12.155 11.2503 12.0003V8.66699V7.91699H12.7503V8.66699V12.0003C12.7503 12.5529 12.5308 13.0828 12.1401 13.4735C11.7494 13.8642 11.2195 14.0837 10.667 14.0837H4.00033C3.44779 14.0837 2.91789 13.8642 2.52719 13.4735C2.13649 13.0828 1.91699 12.5529 1.91699 12.0003V5.33366C1.91699 4.78112 2.13649 4.25122 2.52719 3.86052Z"
        fill="currentColor"
      />
    </svg>
  )
}

ExternalLink.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default ExternalLink
